import React, { useState, useEffect } from "react";
import { useNotification } from "../../context/notification";
import MIUISnackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Snackbar(props) {
  const { notification } = useNotification();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!!notification && !!notification.message) {
      setVisible(true);
    }
  }, [notification]);

  const handleSnackbarClose = () => {
    setVisible(false);
  };

  return (
    <MIUISnackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={3000}
      open={visible}
      onClose={handleSnackbarClose}
    >
      <Alert
        onClose={handleSnackbarClose}
        severity={
          notification
            ? notification.status
              ? notification.status
              : "info"
            : "info"
        }
      >
        {notification ? notification.message : ""}
      </Alert>
    </MIUISnackbar>
  );
}
